import { defineComponent as _defineComponent } from 'vue'
import useIcons from '@/composables/useIcons'
  import { computed, onMounted, ref } from 'vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import { CourseModule } from '@/store/modules/course'
  import useSegment from '@/composables/useSegment'
  import useCourse from '@/composables/useCourse'
  import PackageCoursesSlider from '@/components/course/PackageCoursesSlider.vue'
  import useBreakpoint from '@/composables/useBreakpoint'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import { useRoute } from 'vue-router/composables'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutSuccess',
  setup(__props) {

  const route = useRoute()
  const { diamondIcon, arrowRight } = useIcons()
  const { trackPage, pageViewed } = useSegment()
  const { fetchAllCourseModules, packageId, currentCourseId, firstCourseModule } = useCourse()
  const { isMobileDevice } = useBreakpoint()
  const fetchingData = ref(false)

  const toCourseDetails = () => {
    const moduleId = firstCourseModule.value(currentCourseId.value)?.id || ''
    window.location.href = `/courses/${currentCourseId.value}/module/${moduleId}/start`
  }

  const isOneOffCheckout = computed(() => route.name === 'OneOffCheckoutSuccess')
  const isPackageCheckout = computed(() => route.name === 'PackageCheckoutSuccess')
  const courseBundle = computed(() => CourseModule.courseBundle)

  const fetchCoursesAndModules = async () => {
    if (isPackageCheckout.value) {
      if (CourseModule.courseBundle) {
        fetchAllCourseModules(CourseModule.courseBundle.courses.map((course) => course.id))
      } else {
        await CourseModule.getPackageBundle(packageId.value)
      }
    } else {
      if (!CourseModule.course) {
        await CourseModule.getCourse({ courseId: currentCourseId.value })
      }
      fetchAllCourseModules([CourseModule.course!.id])
    }
    fetchingData.value = false
  }

  fetchingData.value = true
  fetchCoursesAndModules()

  const teaserImageUrl = computed(() => {
    return isMobileDevice.value ? CourseModule.course?.cardTeaserImageUrl : CourseModule.course?.teaserImageUrl
  })

  onMounted(() => {
    trackPage('Success Checkout')
    pageViewed('Success Checkout')
  })

return { __sfc: true,route, diamondIcon, arrowRight, trackPage, pageViewed, fetchAllCourseModules, packageId, currentCourseId, firstCourseModule, isMobileDevice, fetchingData, toCourseDetails, isOneOffCheckout, isPackageCheckout, courseBundle, fetchCoursesAndModules, teaserImageUrl, useIcons, computed, onMounted, ref, KetchUpButton, SVGRenderer, CourseModule, useSegment, useCourse, PackageCoursesSlider, useBreakpoint, LoadingSpinner, useRoute }
}

})